export default __webpack_public_path__ + "static/media/Mystic's Braid of Shimmering Light.3b650452.jpg";